import MicroModal from 'micromodal';
import FormZip from "../base/FormZip";

export default class SpecialOfferModal {
    static init(): void {
        const specialOfferModal = document.querySelector('#special-offer-modal') as HTMLElement || null;

        if (specialOfferModal) {
            var showOfferModal = true;
            var offerModalShownCookie = document.cookie.split('; ').find(row => row.startsWith('offerModalShown='));

            if (offerModalShownCookie) {
                showOfferModal = false;
            }

            var showOfferModalNow = specialOfferModal.getAttribute('data-show-now') === '1';

            if (showOfferModalNow) {
                // Pokud je nastaveno data-show-now="1", zobrazí okno ihned - showNow
                MicroModal.show('special-offer-modal');
            } else if (showOfferModal) {
                setTimeout(function () {
                    MicroModal.show('special-offer-modal', {
                        onShow: () => {
                            // Zde voláme FormZip.init() po zobrazení modálního okna
                            FormZip.getCityRegionByZip('#smartform-address-zip2');
                        }
                    });

                    // Nastaví cookie 'offerModalShown' na 'true' s expirací za 1 den
                    var expiryOfferModalDate = new Date();
                    expiryOfferModalDate.setTime(expiryOfferModalDate.getTime() + (24 * 60 * 60 * 1000)); // Přidá 24 hodin
                    document.cookie = "offerModalShown=true; expires=" + expiryOfferModalDate.toUTCString() + "; path=/";
                }, 30000); // Čeká 30 sekund před spuštěním
            }
        }
    }
}
